// Centralized site/contact constants for Limit Break Performance
export const PHONE_DISPLAY = "(315) 719-5772";
export const PHONE_E164 = "+13157195772";
export const TEL_HREF = `tel:${PHONE_E164}`;
export const SMS_HREF = `sms:${PHONE_E164}`;
export const INSTAGRAM_HANDLE = "Limitbreakperformance";
export const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_HANDLE}`;
export const TIKTOK_HANDLE = "limitbreakperformance_";
export const TIKTOK_URL = `https://www.tiktok.com/@${TIKTOK_HANDLE}`;
export const FACEBOOK_URL = "https://www.facebook.com/profile.php?id=61576742215120";
export const SERVICE_AREA = "Hampton Roads, VA";
export const SERVICE_AREA_LONG = "Virginia Beach · Norfolk · Chesapeake · Portsmouth";
export const BRAND = "Limit Break Performance";
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/kqj96fw1_image.png";

// ===== Rev Cash =====
export const REV_CASH_AMOUNT = 50;
export const REV_CASH_TIERS = [
    {
        key: "bronze",
        title: "Bronze Referrer",
        threshold: 3,
        color: "from-amber-700/30 to-amber-900/10 border-amber-700/40",
        accent: "text-amber-500",
        perks: [
            "Priority booking",
            "Bronze badge on your profile",
            "Occasional perk discounts",
        ],
    },
    {
        key: "silver",
        title: "Silver Referrer",
        threshold: 5,
        color: "from-zinc-400/20 to-zinc-700/10 border-zinc-300/30",
        accent: "text-zinc-200",
        perks: [
            "+$100 bonus Rev Cash on top of $50/referral",
            "Priority scheduling",
            "Free basic inspection with any service",
        ],
    },
    {
        key: "gold",
        title: "Gold Referrer",
        threshold: 10,
        color: "from-yellow-500/30 to-yellow-700/10 border-yellow-500/50",
        accent: "text-yellow-400",
        perks: [
            "+$250 bonus Rev Cash on top of all earnings",
            "First-priority booking — front of the line",
            "Free diagnostic once per year",
            "Exclusive Limit Break merch (coming soon)",
        ],
    },
];

// ===== Stock photo helpers (Unsplash, all verified car/automotive content) =====
const STOCK = {
    // Service categories
    brakes: "https://images.unsplash.com/photo-1573763619610-154c270f83a9?auto=format&fit=crop&w=1200&q=80", // chrome wheel + brake
    suspension: "https://images.unsplash.com/photo-1612825173281-9a193378527e?auto=format&fit=crop&w=1200&q=80",
    diagnostics: "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?auto=format&fit=crop&w=1200&q=80", // dashboard
    installs: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&w=1200&q=80",
    maintenance: "https://images.unsplash.com/photo-1731593481826-6b880b16c9d1?auto=format&fit=crop&w=1200&q=80", // car engine
    repairs: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1200&q=80",
    tuning: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1200&q=80",
    mods: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
    // Gallery covers
    subaru: "https://images.unsplash.com/photo-1606152421802-db97b9c7a11b?auto=format&fit=crop&w=1200&q=80",
    mazda: "https://images.unsplash.com/photo-1581540222194-0def2dda95b8?auto=format&fit=crop&w=1200&q=80",
    exhaust: "https://images.unsplash.com/photo-1745601297149-ee859160925c?auto=format&fit=crop&w=1200&q=80", // shiny exhaust on red car
    intake: "https://images.unsplash.com/photo-1562095946-82a430b62cf4?auto=format&fit=crop&w=1200&q=80", // pod air filter
    jetta: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1200&q=80",
    engineOut: "https://images.unsplash.com/photo-1681820819530-06e53f08585b?auto=format&fit=crop&w=1200&q=80", // car engine close
    truck: "https://images.unsplash.com/photo-1611016186353-9af58c69a533?auto=format&fit=crop&w=1200&q=80",
    sportsCar: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=1200&q=80",
    sedan: "https://images.unsplash.com/photo-1486496146582-9ffcd0b2b2b7?auto=format&fit=crop&w=1200&q=80",
    inspection: "https://images.unsplash.com/photo-1672588084580-bc29709f0b15?auto=format&fit=crop&w=1200&q=80", // front end of car
    porsche: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80",
    mustang: "https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1200&q=80",
    swayBar: "https://images.unsplash.com/photo-1635322966219-b75ed372eb01?auto=format&fit=crop&w=1200&q=80",
    drumBrake: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1200&q=80",
    // Pricing catalog (per individual service — all unique automotive close-ups)
    cel: "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?auto=format&fit=crop&w=1200&q=80",
    misfire: "https://images.unsplash.com/photo-1607282061628-106a47943a5f?auto=format&fit=crop&w=1200&q=80",
    nostart: "https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80",
    battery: "https://images.unsplash.com/photo-1601063476271-a159c71ab0b3?auto=format&fit=crop&w=1200&q=80",
    noiseDiag: "https://images.unsplash.com/photo-1755288347121-d359d40d0041?auto=format&fit=crop&w=1200&q=80",
    prePurchase: "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=1200&q=80",
    exhaustDiag: "https://images.unsplash.com/photo-1648929159788-c791ff985792?auto=format&fit=crop&w=1200&q=80",
    alignment: "https://images.unsplash.com/photo-1559674697-aea453b06ea9?auto=format&fit=crop&w=1200&q=80",
    oilChange: "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=1200&q=80",
    sparkPlug: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?auto=format&fit=crop&w=1200&q=80",
    coilPack: "https://images.unsplash.com/photo-1620891549027-942fdc95d3f5?auto=format&fit=crop&w=1200&q=80",
    fluids: "https://images.unsplash.com/photo-1622185135505-2d795003994a?auto=format&fit=crop&w=1200&q=80",
    belt: "https://images.unsplash.com/photo-1530319067432-f2a729c03db5?auto=format&fit=crop&w=1200&q=80",
    tuneUp: "https://images.unsplash.com/photo-1502877338535-766e1452684a?auto=format&fit=crop&w=1200&q=80",
    frontBrake: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1200&q=80",
    rearBrake: "https://images.unsplash.com/photo-1573763619610-154c270f83a9?auto=format&fit=crop&w=1200&q=80",
    alternator: "https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?auto=format&fit=crop&w=1200&q=80",
    starter: "https://images.unsplash.com/photo-1626668893632-6f3a4466d22f?auto=format&fit=crop&w=1200&q=80",
    controlArm: "https://images.unsplash.com/photo-1623298317883-6b70254edf31?auto=format&fit=crop&w=1200&q=80",
    struts: "https://images.unsplash.com/photo-1635322966219-b75ed372eb01?auto=format&fit=crop&w=1200&q=80",
    cvAxle: "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?auto=format&fit=crop&w=1200&q=80",
    sensor: "https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80",
    exhaustInstall: "https://images.unsplash.com/photo-1747160134919-d84cef52df47?auto=format&fit=crop&w=1200&q=80",
    transTune: "https://images.unsplash.com/photo-1612825173281-9a193378527e?auto=format&fit=crop&w=1200&q=80",
    ecuTune: "https://images.unsplash.com/photo-1607282061628-106a47943a5f?auto=format&fit=crop&w=1200&q=80",
    limiterDelete: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
    o2Sensor: "https://images.unsplash.com/photo-1581093450021-4a7360e9a6b5?auto=format&fit=crop&w=1200&q=80",
    dataLog: "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?auto=format&fit=crop&w=1200&q=80",
    coilover: "https://images.unsplash.com/photo-1612825173281-9a193378527e?auto=format&fit=crop&w=1200&q=80",
    customMod: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1200&q=80",
    buildPlan: "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?auto=format&fit=crop&w=1200&q=80",
    muffler: "https://images.unsplash.com/photo-1648929159788-c791ff985792?auto=format&fit=crop&w=1200&q=80",
    coldAir: "https://images.unsplash.com/photo-1730201127761-15888d9ddf98?auto=format&fit=crop&w=1200&q=80",
    // Articles
    inspectionShop: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?auto=format&fit=crop&w=1200&q=80",
    emissions: "https://images.unsplash.com/photo-1741740158731-25ae5e60b2e6?auto=format&fit=crop&w=1200&q=80",
    brakePadCost: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1200&q=80",
};

// ===== Top-level Services (used on /services) =====
export const SERVICES = [
    {
        slug: "brakes",
        title: "Brakes",
        short: "Pads, rotors, calipers, lines — stopping power you can trust.",
        long:
            "Grinding, squealing, soft pedal? I'll diagnose it and swap in quality pads, rotors, or full brake upgrades. Street-friendly and track-ready options available.",
        image: STOCK.brakes,
    },
    {
        slug: "suspension",
        title: "Suspension & Coilovers",
        short: "Coilover installs, lowering springs, alignments-ready setups.",
        long:
            "Dropping your car the right way. Full coilover installs, spring swaps, control arms, sway bars, and corner balancing guidance. Ride height dialed in where you want it.",
        image: STOCK.suspension,
    },
    {
        slug: "diagnostics",
        title: "Diagnostics",
        short: "Check engine lights, weird noises, electrical gremlins.",
        long:
            "Professional OBD scans plus real-world Ford dealership experience. I chase down codes, rattles, misfires, and electrical issues — then tell you straight what it needs.",
        image: STOCK.diagnostics,
    },
    {
        slug: "installs",
        title: "General Installs & Repairs",
        short: "Intakes, exhaust, tunes, bolt-ons, fluid services, more.",
        long:
            "Cold air intakes, catbacks, headers, tune handheld flashes, spark plugs, fluids, belts, timing components. If it bolts on or wrenches off, I can handle it mobile.",
        image: STOCK.installs,
    },
];

// ===== GALLERY (Work) =====
export const GALLERY = [
    {
        slug: "sway-bar-end-link-diag",
        title: "Sway Bar End Links — Diagnosed & Replaced",
        caption:
            "Found play in the end links and torn boots running metal-to-metal. Caught it before it killed the bushings.",
        cover: STOCK.suspension,
        image: STOCK.suspension,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/chl2d80x_image.png",
        ],
        vehicle: "Daily-driver sedan",
        serviceType: "Suspension Diagnosis & Repair",
        timeOnSite: "About 1.5 hours",
        details: [
            "Customer reported a clunk over bumps. Pulled the wheel, grabbed the sway bar end link and felt obvious play. Inspected the boots — sliced open with no grease left, so the ball stud was running metal-to-metal inside the housing. That's the source of the clunk and would have eaten the sway bar bushings next.",
            "Replaced both front end links, regreased the sway bar bushings, torqued to spec, and road-tested. Clunk gone, steering feels tighter through corners.",
        ],
        pricing: {
            us: 160,
            dealership: 320,
            includes: "Inspection, both front end links replaced, sway bar bushing greasing, torque-to-spec, road test. Parts billed separately.",
        },
    },
    {
        slug: "rear-drum-brake-refresh",
        title: "Rear Drum Brakes — Shoes, Hardware & Adjustment",
        caption:
            "Drum was being held by over-extended shoes. Reset the self-adjuster, fresh hardware, verified no drag.",
        cover: STOCK.brakes,
        image: STOCK.brakes,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/qlltyodd_image.png",
        ],
        vehicle: "Compact car",
        serviceType: "Rear Drum Brake Service",
        timeOnSite: "About 2 hours",
        details: [
            "Customer had a soft parking brake and a scraping noise from the rear. Pulled the drum and found the shoes had been pushed out way past their adjustment limit — they were holding the drum on instead of the wheel cylinder. That's why the brake pedal felt mushy too.",
            "Installed new shoes, full hardware kit, fresh return springs, cleaned and re-set the self-adjuster, and reset the parking brake cable tension. Spun the wheel with the drum and lugnuts on to verify zero drag, then road-tested the brakes.",
        ],
        pricing: {
            us: 140,
            dealership: 360,
            includes: "Shoes, springs + complete hardware kit, drum cleanup, parking brake adjustment, no-drag verification, road test.",
        },
    },
    {
        slug: "front-end-multi-inspection",
        title: "Front-End Multi-Point Inspection & Repair",
        caption:
            "Big front-end refresh — rotors, calipers, tie-rods, all checked, reported, and repaired in one visit.",
        cover: STOCK.inspection,
        image: STOCK.inspection,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/wonapc8b_image.png",
        ],
        vehicle: "Mid-size sedan",
        serviceType: "Front-End Diagnostic + Repair",
        timeOnSite: "Full-day mobile job",
        details: [
            "Customer wanted a real look at the front end before committing to repairs. Pulled both wheels, inspected rotor surfaces (caught noticeable lipping near minimum spec), looked over caliper slide pins and pad wear, and grabbed the tie-rod ends to feel for play.",
            "Once the customer signed off on the photo report, knocked out the rotor + pad replacement, serviced the caliper hardware, swapped the worn tie-rod ends, and re-checked everything before a road test. One stop, full front-end refresh, photographed every step.",
        ],
        pricing: {
            us: 700,
            dealership: 1450,
            includes: "Both front wheels off, rotor + pad replacement, caliper service, tie-rod end replacement, alignment-ready geometry check, photo report, road test. Parts billed separately.",
        },
    },
    {
        slug: "f150-fx4-service",
        title: "Ford F-150 FX4 — Mobile Service Call",
        caption:
            "Took care of an F-150 FX4 on-site. Truck-specific work, dealer-trained.",
        cover: STOCK.truck,
        image: STOCK.truck,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/ov8c1rh5_image.png",
        ],
        vehicle: "Ford F-150 FX4",
        serviceType: "Truck Service",
        timeOnSite: "About 2 hours",
        details: [
            "Customer's F-150 FX4 came in for a service write-up. Being Ford-trained, F-Series work is what I do every day — diagnosed, knocked out the work, and had the truck buttoned up faster than a typical shop ticket.",
            "If you've got an F-150, Super Duty, Explorer, Mustang, or anything else with the blue oval, you're not getting handed off to a tech who's still learning the platform. Ford is my main lane.",
        ],
        pricing: {
            us: 180,
            dealership: 320,
            includes: "Diagnosis, repair labor, road-test, written summary. Parts billed separately.",
        },
    },
    {
        slug: "subaru-coilover-install",
        title: "Subaru — Coilover Install",
        caption:
            "Full coilover swap on a 1st-gen Subaru. Stance dialed, ride still livable.",
        cover: STOCK.subaru,
        image: STOCK.subaru,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/u9y6mqlv_image.png",
        ],
        vehicle: "1st-gen Subaru Forester",
        serviceType: "Coilover Installation",
        timeOnSite: "About 4 hours",
        details: [
            "Customer wanted a clean drop without the harsh ride. Pulled the factory struts and swapped to a full coilover kit, set the ride height per their preference, and verified spring perch tension before reinstalling.",
            "Test-drove for road manners, then sent them to a partner shop for the alignment so the front camber and toe stay true. Result: dropped, dialed, and not killing the daily-drive feel.",
        ],
        pricing: {
            us: 500,
            dealership: 950,
            includes:
                "Full coilover install (front and rear), height set, road test. Alignment recommended after.",
        },
    },
    {
        slug: "mazda-protege-struts-cv",
        title: "Mazda Protégé — Rear Struts & Front-Left CV Axle",
        caption:
            "'02 Mazda Protégé got tired suspension and a clicking front-left CV. Both fixed in one visit.",
        cover: STOCK.mazda,
        image: STOCK.mazda,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/73ukwyyb_IMG_7434.PNG",
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/n4oazuhl_IMG_7435.PNG",
        ],
        vehicle: "2002 Mazda Protégé",
        serviceType: "Suspension & Drivetrain",
        timeOnSite: "About 4 hours",
        details: [
            "Customer reported a crunchy ride and a clicking sound when turning left. Pulled the rear struts and confirmed they were shot — replaced both. Front-left CV axle had a torn boot and was clicking under throttle in tight turns, so we swapped it out same visit.",
            "Bolted everything to spec, lubed the slide hardware, and road-tested. Steering tightened up and the rear stopped bouncing over expansion joints.",
        ],
        pricing: {
            us: 305,
            dealership: 720,
            includes:
                "Rear strut replacement (both), front-left CV axle replacement, road test. Parts billed separately.",
        },
    },
    {
        slug: "exhaust-leak-diagnostic",
        title: "Exhaust Leak Diagnostic",
        caption:
            "Cold-start hiss and a rough-running CEL. Tracked the leak under the car in 30 minutes.",
        cover: STOCK.exhaust,
        image: STOCK.exhaust,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/mlre5o0w_image.png",
        ],
        vehicle: "Compact sedan",
        serviceType: "Exhaust Diagnostic",
        timeOnSite: "About 45 minutes",
        details: [
            "Customer noticed a hissing sound on cold starts and got a CEL. Pulled the car onto stands and pressure-tested the exhaust — found a hairline crack in the flex section just downstream of the cat.",
            "Wrote up a quote for the repair and sent it over. No upsell, no scare-tactics — just the facts and a fair number.",
        ],
        pricing: {
            us: 60,
            dealership: 140,
            includes:
                "Visual + pressure exhaust inspection, written diagnosis, photos for reference. Repair quoted separately.",
        },
    },
    {
        slug: "cold-air-intake-install",
        title: "Cold Air Intake Install",
        caption:
            "K&N-style intake swap. More flow, throatier sound, crisper throttle.",
        cover: STOCK.intake,
        image: STOCK.intake,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/i91udedy_image.png",
        ],
        vehicle: "Daily-driver coupe",
        serviceType: "Cold Air Intake Install",
        timeOnSite: "About 1.5 hours",
        details: [
            "Removed the factory airbox and stock intake tube. Cleaned up the bay, mounted the new cold air intake with the conical filter, reused the MAF, and routed the new tubing without rubbing on anything.",
            "Reset fuel trims to let the ECU relearn airflow. Customer immediately noticed deeper intake note and crisper throttle response.",
        ],
        pricing: {
            us: 100,
            dealership: 280,
            includes: "Removal of factory intake, install of customer-supplied kit, ECU relearn, road test.",
        },
    },
    {
        slug: "vw-jetta-gli-wheels",
        title: "VW Jetta GLI — Wheels & Caliper Refresh (My Car)",
        caption:
            "My own Jetta GLI on fresh wheels with red calipers popping through. Built it. Drive it. Wrenched on it myself.",
        cover: STOCK.jetta,
        image: STOCK.jetta,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/9260r34l_IMG_7212.jpeg",
        ],
        vehicle: "Volkswagen Jetta GLI (owner's car)",
        serviceType: "Wheel & Tire Install + Caliper Refresh",
        timeOnSite: "About 3 hours",
        details: [
            "This is my personal Jetta GLI — every job I've done on this car is hands-on experience that translates directly to your job. I swapped to a set of aftermarket black multi-spoke wheels, mounted and balanced fresh tires, torqued to spec with a follow-up re-torque after a road test. Calipers got a refresh in red so they pop through the spokes.",
            "Working on my own car is how I keep sharp on the smaller details — mounting balance, hub-centric fitment, brake bleed sequencing. You're getting a tech who tests the work on his own ride first.",
        ],
        pricing: {
            us: 250,
            dealership: 480,
            includes: "Mounting, balancing, valve stems, torque + re-torque, road test, caliper detail.",
        },
    },
    {
        slug: "engine-out",
        title: "Engine Out — Full Powertrain Job (My Car)",
        caption: "My own car. Engine pulled in the driveway. Shown here as a reference for experience — Limit Break does not currently offer engine swaps/rebuilds.",
        cover: STOCK.engineOut,
        image: STOCK.engineOut,
        workPhotos: [
            "https://customer-assets.emergentagent.com/job_brake-performance-va/artifacts/erg2gqdo_IMG_7211.jpeg",
        ],
        vehicle: "Honda 4-cyl sedan (owner's car)",
        serviceType: "Engine Removal & Service",
        timeOnSite: "Multi-day mobile job",
        // Reference-only jobs show experience but are NOT services we currently
        // offer. The work-detail page hides the pricing card + quote CTA and
        // shows a small notice instead. (See WorkDetail.jsx.)
        referenceOnly: true,
        referenceNote:
            "Reference job — Limit Break does not currently offer engine swaps/rebuilds.",
        details: [
            "This was my own car — major engine work I knocked out in my own driveway with the hoist. Inspected clutch, flywheel, rear main, and motor mounts, reassembled, fluids filled, leak-checked, and road-tested.",
            "Why this matters for you: pulling an engine on your own ride is how you really learn the platform — torque sequences, sealing surfaces, harness routing, leak-check discipline. That's experience that pays off when something complicated rolls into your driveway and you need a tech who's actually done it.",
        ],
        pricing: {
            // Kept for backward-compat (other code paths read this). The
            // pricing card itself is hidden via `referenceOnly`.
            us: 0,
            dealership: 0,
            includes: "Engine pull + reinstall, clutch + flywheel inspection, mount replacement, fluid services, full road test.",
        },
    },
];

// ===== Articles =====
export const BLOG_POSTS = [
    {
        slug: "virginia-2026-emissions-update",
        title: "Virginia 2026 Emissions & Inspection Update — What's Changing",
        excerpt:
            "Quick rundown of the inspection rule changes in Virginia for 2026, who's affected, and what you should be doing now.",
        date: "2026-01-12",
        readTime: "3 min read",
        cover: STOCK.diagnostics,
        body: [
            "If you drive in Virginia, the inspection and emissions landscape just shifted again. Here's the cliff-notes version so you don't have to dig through DMV PDFs.",
            "What's changing: a few northern counties added stricter OBD-II emissions screening, fines for expired stickers ticked up, and there's new language around modified exhaust systems being checked at safety inspection. Hampton Roads itself stayed mostly status quo — safety inspections still required annually — but if you've got modded exhaust or deleted cats, it's worth knowing where the line is.",
            "What to do now: take a quick look at your sticker before it expires (most lapses happen because nobody noticed, not because the car would fail). If you've got a CEL, get it diagnosed before inspection time — most shops will fail an active CEL on an OBD-II screen.",
            "If you've got tuning or aftermarket exhaust on the car, text us and we'll tell you straight whether it'll pass or whether you need a stock-flash before sticker season.",
        ],
    },
    {
        slug: "why-brake-prices-keep-climbing",
        title: "Why Brake Pad Prices Keep Climbing (And What It Means For You)",
        excerpt:
            "Pads, rotors, and brake fluid have been quietly going up for two years straight. Here's why — and how to time your next brake job to avoid the sting.",
        date: "2025-12-04",
        readTime: "4 min read",
        cover: STOCK.brakes,
        body: [
            "If you priced out a brake job this year and felt like the number was higher than last time, you're not imagining it. Pad and rotor prices have crept up roughly 12-18% across most platforms over the last 24 months, and a few specific platforms (European luxury, EVs with regen-specific pads) are up even more.",
            "The reasons: raw material costs (steel and friction compound), supply chain reset after 2022, and a quiet shift in OEM manufacturers consolidating to fewer suppliers. Aftermarket caught up, then passed factory pricing on a lot of lines.",
            "What this means for you: if your pads are at 4-5mm, don't wait until they're squealing. Doing brakes proactively while pads are still cheap-ish is way better than waiting until you also need rotors and (worst case) calipers.",
            "We watch parts pricing weekly and can tell you whether to do brakes this month or wait — text the make/model/year and a rough mileage and we'll give you a real answer.",
        ],
    },
    {
        slug: "hampton-roads-inspection-guide",
        title: "Hampton Roads Inspection Sticker Guide — Pass The First Time",
        excerpt:
            "What inspectors actually check, what fails the most cars in our area, and the 5-minute pre-check you should do every spring.",
        date: "2025-10-22",
        readTime: "5 min read",
        cover: STOCK.inspection,
        body: [
            "Virginia state inspection is a yearly box-check most people forget about until the sticker on their windshield turns red. Here's what we see fail most often in Hampton Roads — and how to catch it before the inspector does.",
            "Top-5 fails we see at the dealership and on mobile jobs: (1) burned-out license plate or tag light, (2) cracked windshield in the wiper sweep area, (3) torn or dry-rotted wiper blades, (4) tires below 2/32 tread or with sidewall damage, (5) brake pads under 2mm or rotors with deep grooves.",
            "Everything in that list is a sub-$50 fix if you catch it ahead of time. Catch it at the inspection station and you're paying for the same parts plus a re-inspection fee plus the runaround.",
            "Five-minute pre-check: walk around the car at night with someone, hit the brakes / blinkers / reverse / plate light from each angle. Test wipers wet. Eyeball your tread with a quarter (Washington's head should be partly hidden). Push the car gently — listen for clunks. Ten minutes of attention saves you a Saturday.",
            "Want a pre-inspection look-over before you take it in? Text us. $30 and we tell you everything that's going to fail, in your driveway. Way cheaper than the re-inspection fee.",
        ],
    },
];

// ===== Testimonials =====
// Empty until real customer reviews come in. Will grow over time as feedback accumulates.
export const EXTERNAL_TESTIMONIALS = [];

// ===== Service Catalog (Pre-Quote / Pricing) =====
// All prices are STARTING ESTIMATES — final price depends on vehicle, parts, and condition.
export const SERVICE_CATEGORIES = [
    "All",
    "Diagnostics",
    "Maintenance",
    "Repairs",
    "Tuning",
    "Mods & Performance",
];

// AI-generated photos (Gemini Nano Banana) served from the backend at /api/static/*.
// Each service catalog row + four user-requested gallery covers point at a unique,
// description-matched image generated specifically for that service.
const _API = process.env.REACT_APP_BACKEND_URL || "";
const S = (slug) => `${_API}/api/static/services/${slug}.png`;
const G = (slug) => `${_API}/api/static/gallery/${slug}.png`;
const A = (slug) => `${_API}/api/static/articles/${slug}.png`;

export const SERVICE_CATALOG = [
    // ===== DIAGNOSTICS =====
    { slug: "cel-diag", title: "Check Engine Light Diagnosis", category: "Diagnostics", duration: "45 min", price: "Starting at $60", image: S("cel-diag") },
    { slug: "misfire-diag", title: "Misfire / Drivability Diagnosis", category: "Diagnostics", duration: "1 hr", price: "Starting at $75", image: S("misfire-diag") },
    { slug: "no-start-diag", title: "No-Start Diagnosis", category: "Diagnostics", duration: "1 hr", price: "Starting at $90", image: S("no-start-diag") },
    { slug: "battery-charging-diag", title: "Battery / Charging System Diagnosis", category: "Diagnostics", duration: "30 min", price: "Starting at $60", image: S("battery-charging-diag") },
    { slug: "noise-diag", title: "Suspension / Brake Noise Diagnosis", category: "Diagnostics", duration: "45 min", price: "Starting at $60", image: S("noise-diag") },
    { slug: "pre-purchase-inspection", title: "Pre-Purchase Inspection", category: "Diagnostics", duration: "1 hr 30 min", price: "Starting at $100", image: S("pre-purchase-inspection") },
    { slug: "exhaust-leak-diag", title: "Exhaust Leak Diagnosis", category: "Diagnostics", duration: "45 min", price: "Starting at $60", image: S("exhaust-leak-diag") },
    { slug: "alignment-check", title: "Alignment Check / Diag", category: "Diagnostics", duration: "30 min", price: "Starting at $60", image: S("alignment-check") },

    // ===== MAINTENANCE =====
    { slug: "oil-change-labor", title: "Oil Change (labor)", category: "Maintenance", duration: "30 min", price: "Starting at $50", image: S("oil-change-labor") },
    { slug: "spark-plugs", title: "Spark Plug Replacement", category: "Maintenance", duration: "1 hr", price: "Starting at $80", image: S("spark-plugs") },
    { slug: "coil-install", title: "Ignition Coil Install", category: "Maintenance", duration: "45 min", price: "Starting at $60", image: S("coil-install") },
    { slug: "fluid-services", title: "Fluid Services (top-off / flush)", category: "Maintenance", duration: "30 min", price: "Starting at $60", image: S("fluid-services") },
    { slug: "belt-replacement", title: "Belt Replacement", category: "Maintenance", duration: "1 hr", price: "Starting at $90", image: S("belt-replacement") },
    { slug: "tune-up-package", title: "Tune-Up Package", category: "Maintenance", duration: "2 hr", price: "Starting at $150", image: S("tune-up-package") },
    { slug: "alignment-adjust", title: "Alignment Adjustment", category: "Maintenance", duration: "45 min", price: "Starting at $80", image: S("alignment-adjust") },

    // ===== REPAIRS =====
    { slug: "front-brake-pads-rotors", title: "Front Brake Pads & Rotors (labor)", category: "Repairs", duration: "1 hr 30 min", price: "Starting at $120", image: S("front-brake-pads-rotors") },
    { slug: "rear-brake-pads-rotors", title: "Rear Brake Pads & Rotors (labor)", category: "Repairs", duration: "1 hr 30 min", price: "Starting at $140", image: S("rear-brake-pads-rotors") },
    { slug: "alternator-replacement", title: "Alternator Replacement (labor)", category: "Repairs", duration: "2 hr", price: "Starting at $120", image: S("alternator-replacement") },
    { slug: "starter-replacement", title: "Starter Replacement (labor)", category: "Repairs", duration: "2 hr", price: "Starting at $140", image: S("starter-replacement") },
    { slug: "battery-install", title: "Battery Install", category: "Repairs", duration: "20 min", price: "Starting at $40", image: S("battery-install") },
    { slug: "control-arm-tie-rod", title: "Control Arm / Tie Rod / Sway Bar Link", category: "Repairs", duration: "1 hr", price: "Starting at $100 each", image: S("control-arm-tie-rod") },
    { slug: "struts-shocks", title: "Struts / Shocks Replacement", category: "Repairs", duration: "2 hr", price: "Starting at $120 each", image: S("struts-shocks") },
    { slug: "cv-axle-replacement", title: "CV Axle Replacement", category: "Repairs", duration: "2 hr", price: "Starting at $140 each", image: S("cv-axle-replacement") },
    { slug: "sensor-replacement", title: "Sensor Replacements", category: "Repairs", duration: "1 hr", price: "Starting at $80", image: S("sensor-replacement") },
    { slug: "exhaust-bolton-install", title: "Exhaust Bolt-On Install", category: "Repairs", duration: "1 hr 30 min", price: "Starting at $100", image: S("exhaust-bolton-install") },

    // ===== TUNING =====
    { slug: "transmission-tuning", title: "Transmission Tuning", category: "Tuning", duration: "1 hr", price: "Varies by vehicle", image: S("transmission-tuning") },
    { slug: "ecu-tuning", title: "ECU Tuning", category: "Tuning", duration: "2 hr", price: "Varies by vehicle", image: S("ecu-tuning") },
    { slug: "limiter-delete", title: "Limiter Delete", category: "Tuning", duration: "45 min", price: "$200", image: S("limiter-delete") },
    { slug: "wideband-o2-install", title: "Wideband O2 Sensor Install", category: "Tuning", duration: "2 hr 25 min", price: "$150–200", image: S("wideband-o2-install") },
    { slug: "diagnostics-datalogging", title: "Diagnostics & Datalogging (tuning)", category: "Tuning", duration: "45 min", price: "Starting at $80", image: S("diagnostics-datalogging") },

    // ===== MODS & PERFORMANCE =====
    { slug: "cold-air-intake-install", title: "Cold Air Intake Install", category: "Mods & Performance", duration: "1 hr", price: "$100", image: S("cold-air-intake-install") },
    { slug: "muffler-delete", title: "Muffler Delete", category: "Mods & Performance", duration: "1 hr 30 min", price: "$100–200", image: S("muffler-delete") },
    { slug: "coilover-install", title: "Coilover Installation", category: "Mods & Performance", duration: "4 hr", price: "$500", image: S("coilover-install") },
    { slug: "custom-mod-install", title: "Custom Mod Installation", category: "Mods & Performance", duration: "1 hr+", price: "Describe on booking", image: S("custom-mod-install") },
    { slug: "build-plan", title: "Build Plan Consultation", category: "Mods & Performance", duration: "45 min", price: "$50", image: S("build-plan") },
];

// Override the four gallery covers the owner specifically asked for —
// AI-generated to match the exact make/model and subject of each job.
const _GALLERY_COVER_OVERRIDES = {
    "sway-bar-end-link-diag": G("sway-bar-end-link-diag"),
    "f150-fx4-service": G("f150-fx4-service"),
    "subaru-coilover-install": G("subaru-coilover-install"),
    "mazda-protege-struts-cv": G("mazda-protege-struts-cv"),
};
GALLERY.forEach((j) => {
    const o = _GALLERY_COVER_OVERRIDES[j.slug];
    if (o) {
        j.cover = o;
        j.image = o;
    }
});

// Article covers — AI-generated, one unique image per post, matched to the topic.
BLOG_POSTS.forEach((p) => {
    p.cover = A(p.slug);
});
